/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import apiInputService from "services/apiInputService";

const getFileSubmitted = async (processId: string) => {
    const { data } = await apiInputService.get(`/ExternalData/updateMassive/file/${processId}`);

    return data;
}

export const useFileSubmittedForBulkUpload = (processId: string, options?: any) => {
    const { subscription } = useSubscription();
    return useQuery(
        ["carga-massiva", subscription?.subscriptionId, processId],
        ()=> getFileSubmitted(processId),
        {
            enabled: !!subscription?.subscriptionId && !!processId,
            ...options,
        }
    );
}